import React, {memo} from "react";
import {get} from "lodash";
import humanizeString from "string-humanize";
import {useDispatch} from "react-redux";
import {useMediaQuery} from "react-responsive";
import ListView from "../../../../components/ContentDisplay/ListView";
import DeleteModal from "../../../../components/Modal/DeleteModal";
import SlugFeedModal from "../../../../components/Modal/SlugFeedModal";
import EditSensorDetailsModal from "../../../../components/Modal/EditSensorDetails";
import SensorSummaryModal from "../../../../components/Modal/SensorSummaryModal";
import ConfirmModal from "../../../../components/Modal/ConfirmModal";
import {acknowledgeOnOff} from "../../../../redux/Actions/controllers.actions";
import {getActionList} from "./summaryActionList";
import SummaryCard from "./summaryCard";
import {useReadySystem, summaryDetailsKeys} from "./summaryTable.constants";
import {useSummaryTableActions} from "./useSummaryTableActions";

const SummaryTable = ({summaryDetails}) => {
  const summaryDetailKeys = summaryDetailsKeys(summaryDetails);
  const dispatch = useDispatch();
  const isMobileOrTablet = useMediaQuery({query: "(max-width: 1080px)"});
  const {
    deleteModalOpen,
    deleteSensorHandler,
    editGroupModelOpen,
    onSaveSlugFeed,
    resetLimitModalOpen,
    resetLimitHandler,
    selectedSensorId,
    sensorSummaryModalOpen,
    setDeleteModalOpen,
    setEditGroupModelOpen,
    setResetLimitModalOpen,
    setSensorSummaryModalOpen,
    setSlugModalOpen,
    setTurnOnOff,
    slugModalOpen,
    turnOnOff,
    setSelectedCheckBoxId,
    turnOnOffHandler,
    handleActionSelection,
  } = useSummaryTableActions();
  const isReady = useReadySystem();

  return (
    <div>
      <DeleteModal
        header={"Delete Sensor"}
        modalBody={"Are you sure you want to delete this sensor?"}
        onClose={() => setDeleteModalOpen(false)}
        onDelete={deleteSensorHandler}
        open={deleteModalOpen}
      />
      <ConfirmModal
        header={"Powered On/Off"}
        modalBody={"Do you wish to disable input?"}
        onClose={() => setTurnOnOff(false)}
        onConfirm={turnOnOffHandler}
        open={turnOnOff}
      />
      {editGroupModelOpen && (
        <EditSensorDetailsModal
          open={editGroupModelOpen}
          onClose={() => setEditGroupModelOpen(false)}
          sensorId={selectedSensorId.id}
        />
      )}
      {sensorSummaryModalOpen && (
        <SensorSummaryModal
          open={sensorSummaryModalOpen}
          toggle={() => setSensorSummaryModalOpen(false)}
          sensorId={selectedSensorId.id}
        />
      )}
      {slugModalOpen && (
        <SlugFeedModal
          open={slugModalOpen}
          onClose={() => setSlugModalOpen(false)}
          onSaveCallback={onSaveSlugFeed}
        />
      )}
      {resetLimitModalOpen && (
        <ConfirmModal
          header={"Reset Limit"}
          modalBody={"Are you sure you want to reset the limit?"}
          onClose={() => setResetLimitModalOpen(false)}
          onConfirm={resetLimitHandler}
          open={resetLimitModalOpen}
        />
      )}
      <div>
        {summaryDetailKeys.map((ioType, index) => {
          const isLastElement = summaryDetailKeys.length - 1 === index;
          return (
            <div
              key={ioType}
              style={{
                borderBottom: `${isLastElement ? 0 : 0.5}px solid gray`,
                margin: isMobileOrTablet ? "10px" : "0px 0px 15px 0px",
                paddingBottom: isMobileOrTablet ? "10px" : "0px",
              }}
            >
              {summaryDetails[ioType].map((each, index) => (
                <div
                  key={`${each.title}_${index}`}
                  style={isMobileOrTablet ? {} : {padding: "15px", paddingTop: "0px"}}
                >
                  <div
                    className="roboto-bold"
                    style={{
                      paddingBottom: "10px",
                      color: "#303030",
                      fontSize: "16px",
                      fontWeight: "bold",
                    }}
                  >
                    <span style={{}}>{ioType.toUpperCase()} : </span>
                    <span style={{}}>{humanizeString(each.title)}</span>
                  </div>
                  <ListView
                    filterActionsOn={"is_powered_on"}
                    actionsList={getActionList(ioType, isReady)}
                    withActions
                    permsForActions={[]}
                    listItems={each.data}
                    listHeaders={each.headers}
                    booleanAsToggle
                    onClickToggle={(row, column, keyValue) => {
                      if (keyValue === false) {
                        dispatch(acknowledgeOnOff(row.id));
                      } else {
                        setSelectedCheckBoxId(row.id);
                        setTurnOnOff(true);
                      }
                    }}
                    onSelectAction={(action, row) =>
                      handleActionSelection(action, {...row, title: each.title})
                    }
                    customRenderKeys={["value"]}
                    customRenderComponent={CustomTableRender}
                    tableName={`${ioType}${each.title}`}
                    rowClickable
                    onSelectRow={(selectedRow) =>
                      handleActionSelection("Click", {...selectedRow, title: each.title})
                    }
                    cardContent={SummaryCard}
                    testId={`${ioType}${each.title}`}
                  />
                </div>
              ))}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default memo(SummaryTable);

const CustomTableRender = ({data, renderKey}) => {
  const value = get(data, "value");
  const inAlarm = get(data, "in_alarm");
  if (renderKey === "value") {
    const className = inAlarm || value === "AT LIMIT" ? "text-danger" : "text-success";
    return <span className={className}>{value}</span>;
  } else {
    return null;
  }
};
